import { Row } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 942px;
  padding-bottom: 80px;

  > .ant-row.ant-row-end {
    margin-bottom: 24px;
  }

  .react-pdf__Page__canvas {
    margin: 0 auto;
  }
`;

export const PdfWrapper = styled(Row)`
  flex-grow: 1;

  .react-pdf__Document {
    padding: 0 16px;
  }

  svg {
    cursor: pointer;
  }
`;

export const DocumentLoaderWrapper = styled.div`
  width: 570px;

  > div {
    position: static;
    height: 100%;
    width: 100%;
  }
`;

export const GlobalModalStyles = createGlobalStyle`
  .ant-modal.pdf-modal {
    width: 960px !important;
    vertical-align: top;
    top: 48px;
  }
`;
